import React, { useState } from "react";
import ReactHtmlParser from "react-html-parser";
import styled from "@emotion/styled";
import Button from "./Button";
import SecondaryButton from "./SecondaryButton";
import TextInput from "./TextInput";
import Colors from "../../assets/Colors.json";

const InputPopup = ({ strings, popupData, setPopupData }) => {
  const PopupBackground = styled.div`
    z-index: 999;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background-color: rgba(0, 0, 0, 0.5);
  `;

  const Popup = styled.div`
    position: absolute;
    width: 70vw;
    height: 70vh;
    max-width: 70%;
    min-width: 20%;
    max-height: 70%;
    min-height: 10%;
    margin: auto;
    padding: 2vh;
    border-radius: 3px;
    background: white;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    text-align: center;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  `;

  const Header = styled.h1`
    font-size: 3vh;
    font-weight: bold;
    color: ${Colors.lightTheme.accentColor1};
  `;

  const Divider = styled.div`
    width: 100px;
    height: 2px;
    background-color: ${Colors.lightTheme.accentColor1};
    margin: 1vh auto;
  `;

  const Option = styled.div`
    ${props => `
        flex: 1 1 calc(${props.multipleRow ? "50%" : "100%"} - 5vh);
        border-radius: 1vh;
        font-size: 2.5vh;
        text-align: center;
        padding: 1.5vh;
        font-weight: bold;
        cursor: pointer;
        border: 1px solid #3C3C3B;
        margin: 1vh;

        ${props.selected ? `
          animation-name: select;
          background: #3C3C3B;
          color: white;
          font-weight: bold;
          ` : `
            background: white;
            animation-name: none;
        `};
    `};
  `;

  const OptionsWrapper = styled.div`
    height: 50vh;
    max-height: 50vh;
    overflow-y: auto;
  `;

  const close = () => {
    setPopupData({ visible: false });
    if (typeof popupData.onClose === "function") {
      popupData.onClose();
    }
  };

  const confirm = () => {
    let isFunction = typeof popupData.onConfirm === "function";
    if (isFunction) {
      popupData.onConfirm();
    }
    close();
  };

  return (
    <React.Fragment>
      {popupData.visible ? (
        <PopupBackground>
          <Popup>
            <Header>{popupData.header}</Header>
            <Divider />
            <OptionsWrapper>
              {(popupData.suboptions || []).map((suboption, i) => {
                return (
                  <Option key={"suboption" + i}
                    selected={suboption?.selected}
                    multipleRow={popupData?.suboptions?.length > 5}
                    onClick={() => { popupData?.actions.selectSubOption(popupData.indexoption, i); close(); }}>
                    {popupData?.config.getTranslatedText(suboption?.option)}
                  </Option>
                );
              })}
            </OptionsWrapper>
            <div style={{margin: "1vh"}}>
              {popupData.confirmation ? (
                <React.Fragment>
                  <SecondaryButton value={popupData.closeText ? popupData.closeText : strings.cancel} action={close} style={{ marginRight: "0.5vw" }} />
                  <Button value={popupData.acceptText ? popupData.acceptText : strings.accept} action={confirm} style={{ marginLeft: "0.5vw" }} />
                </React.Fragment>
              ) : (
                <Button value={popupData.closeText ? popupData.closeText : strings.close} action={close} />
              )}
            </div>
          </Popup>
        </PopupBackground>
      ) : (
        <></>
      )}
    </React.Fragment>
  );
};

export default InputPopup;
